<template>
  <tooltip :text="toolTipContent" v-if="getFirstAssignee">
    <v-badge :content="assignees.length" bottom overlap color="grey darken-1" v-if="assignees.length > 1">
      <user-avatar :user="getUserDetails(getFirstAssignee)" color="info" size="25" text-class="">
        <template #fallback="{ initials }">
          <span class="text-xs white--text">{{ initials }}</span>
        </template>
      </user-avatar>
    </v-badge>
    <user-avatar v-else :user="getUserDetails(getFirstAssignee)" color="info" size="25" text-class="">
      <template #fallback="{ initials }">
        <span class="text-xs white--text">{{ initials }}</span>
      </template>
    </user-avatar>
  </tooltip>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import UserAvatar from "../utility/UserAvatar.vue";

@Component({
  components: { Tooltip, UserAvatar },
  filters: {}
})
export default class TicketDetailCardAssignees extends mixins(RulesMixin, DarkModeHighlightMixin) {
  @Prop()
  assignees!: string[];

  get getFirstAssignee() {
    if (this.assignees.length) {
      return this.assignees[0];
    }
    return undefined;
  }

  get toolTipContent() {
    let tooltip = "";
    for (const userId of this.assignees) {
      tooltip = tooltip + this.getUserName(userId) + "<br>";
    }
    return tooltip;
  }

  getUserDetails(userId: string) {
    return PartnerUserModule.maps.id.get(userId)[0];
  }

  getUserName(userId: string) {
    const user = this.getUserDetails(userId);

    return user ? user.firstName + " " + user.lastName : "";
  }

  getUserMail(userId: string) {
    const user = this.getUserDetails(userId);

    return user ? user.userName : "";
  }
}
</script>
